{
  "accessed": "2026-09-12",
  "publicationDate": "2026-09-09",
  "period": "June 2026",
  "publisher": "U.S. Bureau of Labor Statistics",
  "sourceUrl": "https://www.bls.gov/news.release/ecec.t06.htm",
  "metrics": [
    "Total compensation",
    "Wages and salaries",
    "Total benefits",
    "Paid leave",
    "Supplemental pay",
    "Insurance",
    "Retirement and savings",
    "Legally required benefits"
  ],
  "groups": [
    {
      "size": "All sizes",
      "values": [
        59.8,
        41.55,
        18.24,
        5.2,
        2.67,
        4.36,
        1.94,
        4.07
      ]
    },
    {
      "size": "1-99 workers",
      "values": [
        50.94,
        36.52,
        14.42,
        3.87,
        1.92,
        3.52,
        1.38,
        3.72
      ]
    },
    {
      "size": "1-49 workers",
      "values": [
        51.05,
        36.49,
        14.56,
        3.89,
        1.97,
        3.55,
        1.44,
        3.71
      ]
    },
    {
      "size": "50-99 workers",
      "values": [
        50.58,
        36.65,
        13.93,
        3.81,
        1.76,
        3.41,
        1.19,
        3.76
      ]
    },
    {
      "size": "100 workers or more",
      "values": [
        68.51,
        46.5,
        22.01,
        6.52,
        3.41,
        5.18,
        2.49,
        4.42
      ]
    },
    {
      "size": "100-499 workers",
      "values": [
        59.73,
        41.9,
        17.83,
        5.46,
        2.28,
        4.25,
        1.84,
        3.99
      ]
    },
    {
      "size": "500 workers or more",
      "values": [
        77.6,
        51.26,
        26.34,
        7.61,
        4.57,
        6.15,
        3.16,
        4.86
      ]
    }
  ]
}
